import React from "react";
import {
  SFPageFloatContainer,
} from "@sf-core";
import { useTranslation } from "react-i18next";

const Maintenance = () => {
  const { t } = useTranslation();
  return (
    <SFPageFloatContainer>
      {t("maintenanceScreen.title")}
    </SFPageFloatContainer>
  );
};

export default Maintenance;
